exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".WebSocketStatus{position:absolute;bottom:4rem;right:.3rem;z-index:1010;color:#999;font-size:.8rem;font-family:Roboto,sans-serif}.WebSocketStatus div{display:inline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/Components/WebSocketStatus.scss
// module id = 232
// module chunks = 0